import { Controller, useFormContext } from "react-hook-form";
import { FieldError, FileUploadField, SectionHeading } from "../components";
import {
	PaymentSetupFormValues,
	getDocumentLabel,
	getRequiredDocumentCodes,
} from "../helpers";

const DocumentsStep = () => {
	const {
		control,
		watch,
		formState: { errors },
	} = useFormContext<PaymentSetupFormValues>();

	const tier = watch("tier");
	const requiredCodes = getRequiredDocumentCodes(tier || "");

	if (!tier) {
		return (
			<div>
				<SectionHeading title="Documents" />
				<p className="text-sm text-gray-500">
					Select a tier in Business information first. The documents you need depend on it.
				</p>
			</div>
		);
	}

	const renderDocument = (code: string, required: boolean) => {
		const error = errors.documents?.[code];
		return (
			<div key={code}>
				<p className="text-sm font-medium text-secondary-darkgray flex gap-1">
					{getDocumentLabel(code)}
					{!required && <i className="font-bold">(optional)</i>}
				</p>
				<Controller
					name={`documents.${code}`}
					control={control}
					rules={{
						required: required ? `Upload the ${getDocumentLabel(code).toLowerCase()}` : false,
					}}
					render={({ field }) => (
						<FileUploadField
							value={field.value}
							onChange={field.onChange}
							hasError={!!error}
						/>
					)}
				/>
				<FieldError error={error} />
			</div>
		);
	};

	return (
		<div>
			<SectionHeading
				title="Documents"
				description={`These are the KYC documents required for ${tier}. Upload PDFs or images up to 10 MB each.`}
			/>
			<div className="grid grid-cols-2 gap-x-6 gap-y-5">
				{requiredCodes.map((code) => renderDocument(code, true))}
			</div>
		</div>
	);
};

export default DocumentsStep;
